import { computed, ref } from "vue";
import { defineStore } from "pinia";
import { type UserDTO } from "@shared/types/common";
import { analyticsService } from "@shared/services/analytics";
import { appcuesService } from "@shared/services/appcues";

export const useAuthStore = defineStore("auth", () => {
  // State
  const _user = ref<UserDTO | null>(null);

  // Getters
  const user = computed(() => _user.value);

  // Actions
  const setUser = (newUser: UserDTO | null) => {
    _user.value = newUser;
    analyticsService.setUserIdentityProperties();
    appcuesService.setUserIdentityProperties();
  };

  const clear = async () => {
    _user.value = null;
  };

  const setMfaActivated = (mfaActivated: boolean) => {
    if (_user.value) {
      _user.value.mfaActivated = mfaActivated;
    }
  };

  return {
    user,
    setUser,
    clear,
    setMfaActivated,
  };
});
